(function () {
  function initFaqSection(root) {
    var tabs = root.querySelectorAll('[data-pv-faq-tab]');
    if (tabs.length && root.dataset.pvFaqTabsInit !== 'true') {
      root.dataset.pvFaqTabsInit = 'true';
      var panels = root.querySelectorAll('[data-pv-faq-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var idx = tab.getAttribute('data-pv-faq-tab');
          tabs.forEach(function (other) {
            var active = other === tab;
            other.classList.toggle('is-active', active);
            other.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach(function (panel) {
            panel.hidden = panel.getAttribute('data-pv-faq-panel') !== idx;
          });
        });
      });
    }

    var items = root.querySelectorAll('.js-pv-faq__item');

    items.forEach(function (item) {
      var button = item.querySelector('.pv-faq__question');
      if (!button || item.dataset.pvFaqInit === 'true') return;
      item.dataset.pvFaqInit = 'true';

      function closeAll() {
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var otherBtn = other.querySelector('.pv-faq__question');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });
      }

      function closeItem() {
        item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      }

      function openItem() {
        closeAll();
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }

      function toggleItem() {
        if (item.classList.contains('is-open')) {
          closeItem();
        } else {
          openItem();
        }
      }

      item.addEventListener('click', function (event) {
        if (event.target.closest('a')) return;
        toggleItem();
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pv-faq]').forEach(initFaqSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-pv-faq]');
    if (root) initFaqSection(root);
  });
})();
